'use strict';
var app = require('angular').module('directive.loading', []);

app.directive('loading', [require('./loadingDirective')]);
